"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzCheck = _interopRequireDefault(require("./../OzCheck/OzCheck.js"));

var _consts = require("./../consts.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Table = _styledComponents.default.table.withConfig({
  displayName: "OzTable__Table",
  componentId: "sc-jz6ejk-0"
})(["\n  width: 100%;\n  border-collapse: collapse;\n  border: 0px;\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n\n  ", "\n\n"], function (props) {
  return props.mobileFriendly ? "\n    @media screen and (max-width: 600px) {\n      & thead {\n        display: none;\n      }  \n      & td {\n        display: flex;\n      }\n      \n      & td::before {\n        content: attr(label);\n        font-weight: 600;\n        width: 120px;\n        min-width: 120px;\n      }\n    }    \n  " : null;
});

var THead = _styledComponents.default.thead.withConfig({
  displayName: "OzTable__THead",
  componentId: "sc-jz6ejk-1"
})(["\n  & tr{\n    border-bottom: 1px solid #707070;\n    /*\n    box-shadow: 0px 2px 10px #C1CCE838;\n    z-index: 2;\n    position: relative; */\n  }\n  & tr th{\n    padding: 15px 10px 15px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #303030;\n  }\n"]);

var TBody = _styledComponents.default.tbody.withConfig({
  displayName: "OzTable__TBody",
  componentId: "sc-jz6ejk-2"
})(["\n  & tr:nth-child(odd){\n    background-color: ", "66;\n    border-left: 1px solid ", "66;\n    border-right: 1px solid ", "66;\n    /*z-index: 1;\n    position: relative;*/\n  }\n\n  ", "\n  \n  & tr td a{\n    text-decoration: none;\n    color: inherit;\n    display: block;\n  }\n"], _consts.GHOSTWHITE, _consts.GHOSTWHITE, _consts.GHOSTWHITE, function (props) {
  return props.mobileFriendly ? "\n    @media screen and (min-width: 601px) {\n      & tr td{\n        border-bottom: 1px solid #70707029;\n      }\n      & tr:nth-child(odd) td{\n        border-bottom: 1px solid #50505029;\n      }\n    }\n    @media screen and (max-width: 600px) {\n      & tr td:last-child{\n        border-bottom: 1px solid #707070;\n        padding-bottom: 30px;\n      }\n      & tr td:first-child{\n        padding-top: 30px;\n      }\n    }\n    & tr td a{\n      text-decoration: none;\n      color: inherit;\n      display: block;\n    }\n  " : null;
});

var RowView = _styledComponents.default.tr.withConfig({
  displayName: "OzTable__RowView",
  componentId: "sc-jz6ejk-3"
})(["\n  ", "\n  \n  ", "\n\n  & td{\n    ", "\n  }\n\n  &:hover td{\n    background-color: ", ";\n  }\n\n  cursor: ", ";\n"], function (props) {
  return props.background ? "background-color: " + props.background + " !important;" : null;
}, function (props) {
  return props.isOpen ? "background-color: " + _consts.LILAC + " !important;" : null;
}, function (props) {
  return props.color ? "color: " + props.color + ";" : null;
}, function (props) {
  return props.backgroundHover ? props.backgroundHover : _consts.LILAC;
}, function (props) {
  return props.hasAccordion ? "pointer" : "default";
});

var RowFold = _styledComponents.default.tr.withConfig({
  displayName: "OzTable__RowFold",
  componentId: "sc-jz6ejk-4"
})(["\n  display: ", ";\n  background-color: ", ";\n"], function (props) {
  return props.show ? "table-row" : "none";
}, _consts.LILAC);

var Cell = _styledComponents.default.div.withConfig({
  displayName: "OzTable__Cell",
  componentId: "sc-jz6ejk-5"
})(["\n  ", "\n"], function (props) {
  return props.mobileFriendly ? "\n    @media screen and (min-width: 601px) {\n      font-size: 14px;\n      padding: 15px 10px 15px 10px;\n    }\n  " : null;
});

var OzTable = function OzTable(_ref) {
  var _ref$mobileFriendly = _ref.mobileFriendly,
      mobileFriendly = _ref$mobileFriendly === void 0 ? true : _ref$mobileFriendly,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      values = _ref.values,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? [] : _ref$selected,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect;

  var _useState = (0, _react.useState)(null),
      open = _useState[0],
      setOpen = _useState[1];

  return __jsx(Table, {
    mobileFriendly: mobileFriendly
  }, columns && columns.length > 0 ? __jsx(THead, null, __jsx("tr", null, selectable ? __jsx("th", {
    width: "20px"
  }, __jsx(_OzCheck.default, {
    selected: values.map(function (row) {
      return row.id;
    }).every(function (v) {
      return selected.includes(v);
    }),
    onChange: function onChange() {
      if (values.map(function (row) {
        return row.id;
      }).every(function (v) {
        return selected.includes(v);
      })) {
        onSelect(values.map(function (row) {
          return row.id;
        }));
      } else {
        onSelect(values.map(function (row) {
          return !selected.includes(row.id) ? row.id : null;
        }));
      }
    }
  })) : null, columns.map(function (item, i) {
    return __jsx("th", {
      key: i
    }, item);
  }))) : null, __jsx(TBody, {
    mobileFriendly: mobileFriendly
  }, values.map(function (row, i) {
    var Link = row.link;
    return __jsx(_react.default.Fragment, {
      key: i
    }, __jsx(RowView, {
      background: row.style && row.style.background ? row.style.background : null,
      backgroundHover: row.style && row.style.backgroundHover ? row.style.backgroundHover : null,
      color: row.style && row.style.color ? row.style.color : null,
      onClick: function onClick() {
        return row.accordion && open !== row.id ? setOpen(row.id) : setOpen(null);
      },
      hasAccordion: row.accordion,
      isOpen: open === row.id
    }, selectable ? __jsx("td", {
      width: "20px"
    }, __jsx(Cell, {
      mobileFriendly: mobileFriendly
    }, __jsx(_OzCheck.default, {
      selected: selected.includes(row.id),
      onChange: function onChange() {
        return onSelect([row.id]);
      }
    }))) : null, row.values.map(function (item, j) {
      return __jsx("td", {
        key: j,
        label: columns[j]
      }, Link ? __jsx(Link, null, __jsx(Cell, {
        mobileFriendly: mobileFriendly
      }, item)) : __jsx(Cell, {
        mobileFriendly: mobileFriendly
      }, item));
    })), __jsx(RowFold, {
      show: open === row.id
    }, __jsx("td", {
      colSpan: row.values.length + (selectable ? 1 : 0)
    }, __jsx(Cell, {
      mobileFriendly: mobileFriendly
    }, row.accordion))));
  })));
};

var _default = OzTable;
exports.default = _default;